import { z } from "zod";

const INVALID_LENGTH_MESSAGE =
  "Account number must be between 4 - 17 digits long";

export const bankAccountNumber = () =>
  z
    .string()
    .regex(/^[a-zA-Z0-9]+$/, {
      message: "Account number must be alphanumeric",
    })
    .min(4, { message: INVALID_LENGTH_MESSAGE })
    .max(17, {
      message: INVALID_LENGTH_MESSAGE,
    });
